import Users from './Users.redux';

export default Users;
